import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Route } from 'react-router-dom'
import {Flex} from "../components/layout"
import ProjectsGrid from '../components/ProjectsGrid'
import ProjectsGridMobile from '../components/mobile_ProjectsGrid'
import Overline from '../components/_Overline'
import Filters from '../components/_Filters'
import Project from '../components/Project'
import Superface from '../Superface'

const IPS = [ 
   '78.212.251.144', 
   '5.48.120.102',
   '94.228.187.54', 
   '82.235.118.89',
   '176.160.42.188',
]

class Projects extends React.Component{
   
    componentWillMount(){
        document.title = Superface.translate('Projets') + ' - Superface'
        this.setState({...this.state, mounted : false})
        if( this.props.ip == null ) Superface.getIP()
    }

    componentDidMount(){
        Superface.setCompass('E')
        this.checkProjectsGridActivation(this.props.location.pathname)
        setTimeout(() => {
            this.setState({...this.state, mounted : true})
         }, 1000);
    }
    
    checkProjectsGridActivation(path){
        
        if( path.split('/')[2] !== undefined ){
            Superface.disableProjectsGrid()
        }else{
            Superface.enableProjectsGrid()
        }
    }

    componentWillReceiveProps(new_props){
        if( this.props.location.pathname !== new_props.location.pathname ){
            this.checkProjectsGridActivation(new_props.location.pathname)
        }
      //  console.log(this.props.ip, new_props.ip )
        if( this.props.ip !== new_props.ip && new_props.ip !== null ){
            if( IPS.indexOf(new_props.ip) == -1 ) document.location.href = '/'
        }
    }

    handleClick(mode){
        if( Superface.canDoIt ){
            Superface.setProjectsViewMode(mode)
            Superface.canDoIt = false
        }
    }

    renderNav(){ 
        if( this.props.isOnSingle || Superface.IS_MOBILE_OR_TABLET ) return <span></span>
        return(
            <Flex className='page-top-menu' align='center' justify='center' style={{top: '4.2rem', position:'absolute', zIndex:'940', width : '100%', pointerEvents:'none'}}>
            
                <span 
                    style={{pointerEvents:'all'}}
                    onMouseDown={ (e) => { e.preventDefault(); this.handleClick('galaxy')}} 
                    className={ 'overline-link ' + ( this.props.viewMode === 'timeline' ? '' : 'active' )}
                    >
                    <Overline>Galaxy</Overline>
                </span>
                        
                &nbsp;&nbsp;&nbsp;&nbsp;<span className='top-nav-stroke'></span>&nbsp;&nbsp;&nbsp;&nbsp;

                <span
                    style={{pointerEvents:'all'}}
                    onMouseDown={ (e) => { e.preventDefault(); this.handleClick('timeline')}}
                    className={ 'overline-link ' + ( this.props.viewMode === 'timeline' ? 'active' : '' )}
                    >
                    <Overline>Timeline</Overline>
                </span>
                
            </Flex>    
        )

    }

    renderFilters(){
        if( this.props.viewMode === 'timeline' || Superface.IS_MOBILE_OR_TABLET ) return
        return <Filters  type="projet" filters={this.props.areasFilters} />
    }

    renderProjectDate(){
        if( this.props.projects.length === 0 || this.props.viewMode !== 'timeline' || Superface.IS_MOBILE ) return 
        
        let date = this.props.projects[this.props.currentTimeLineProjectIndex].date
        date = date.split('-')[0]
        return(
            <div className="projects-date" style={{position : 'fixed', top:'8rem', textAlign:'center', fontSize:'1.7rem', zIndex:400}}>
                <div>{ date }</div>
            </div>
        )
    }

    
    renderProjectName(){
        if( this.props.projects.length === 0 || this.props.viewMode !== 'timeline' || Superface.IS_MOBILE ) return 
        // console.log( this.props.projects[ this.props.currentTimeLineProjectIndex ] )
        return(
            <div className="projects-name" style={{position : 'fixed', bottom:'4rem', textAlign:'center'}}>
                { Superface.field(this.props.projects[this.props.currentTimeLineProjectIndex].activity_area, 'display') }
                <div style={{fontSize:'1.7rem', marginTop:'1.5rem'}}>{ Superface.field(this.props.projects[this.props.currentTimeLineProjectIndex], 'name') }</div>
                
            </div>
        )
    }

    renderGrid(){
        if( Superface.IS_MOBILE ){
            return(
                <ProjectsGridMobile 
                    projects={this.props.projects}
                    />
            )
        }else{
            return(
                <ProjectsGrid 
                        mounted={this.state.mounted}
                        areasFilters={this.props.areasFilters} 
                        projects={this.props.projects}
                        active={ this.props.projectsGridActive && this.props.viewMode !== 'timeline' }
                        mode={ this.props.viewMode }
                        currentTimeLineProjectIndex={this.props.currentTimeLineProjectIndex}
                        isOnSingle={this.props.isOnSingle}
                        />
            )
        }
    }

    render(){
        
        return(
            <div 
                id="projects" 
                className={((this.state.mounted)  ? 'mounted' : '') + (this.props.mapLeaving ? ' leave' : '')} 
                style={{overflow:'hidden', width:'100%', height:'100%', backgroundColor:'white', cursor:this.props.cursor }}
                >
                           
                <Flex  align='center' justify='center' style={{backgroundColor:'white', width:'100%', height:'100%'}}>
                    
                    <Route path={ Superface.uri('projets') + '/:slug'} render={
                        (props) => {
                            return(
                                <Project projects={this.props.projects} singleLeaving={this.props.singleLeaving}/>
                            )
                        }
                    }/>
                    
                    {this.renderProjectDate()}
                    {this.renderNav()}
                    {this.renderGrid()}
                    {this.renderFilters()}
                    {this.renderProjectName()}

                </Flex>
                           
                   
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    
	return {
        ip : state.app.ip,
        singleLeaving : state.app.singleLeaving,
        mapLeaving : state.app.mapLeaving,
        areasFilters : state.app.areasFilters,
        projectsGridActive : state.app.projectsGridActive,
        projects : state.data.projects,
        projectsAreas : state.data.projectsAreas,
        viewMode : state.app.projectsViewMode,
        currentTimeLineProjectIndex : state.app.currentTimeLineProjectIndex,
        cursor : state.app.cursor,
        isOnSingle : state.app.isOnSingle
	}
}

export default withRouter(connect(
	mapStateToProps,
    null
)(Projects))



// WEBPACK FOOTER //
// ./src/containers/Projects.js